import type { Superpower } from '@fyf/shared';
import { BRAND_COPY, SUPERPOWERS } from '@fyf/shared';

import { OptionGrid } from '../components/OptionGrid.js';
import { ScreenLayout } from '../components/ScreenLayout.js';
import { StepIndicator } from '../components/StepIndicator.js';
import { SubmitButton } from '../components/SubmitButton.js';
import { useCaptureDispatch, useCaptureState } from '../context/CaptureFlowContext.js';

const { superpower: copy } = BRAND_COPY.screens;

export function SuperpowerScreen() {
  const { superpower } = useCaptureState();
  const dispatch = useCaptureDispatch();

  function handleSelect(value: Superpower) {
    dispatch({ type: 'SET_SUPERPOWER', payload: value });
  }

  function handleNext() {
    if (superpower) {
      dispatch({ type: 'SET_SCREEN', payload: 'feeling' });
    }
  }

  return (
    <ScreenLayout>
      <StepIndicator label={copy.stepLabel} currentStep={1} />
      <h2 className="text-[32px] font-['Lora',serif] text-center mb-6">
        What&rsquo;s your
        <br />
        <span className="text-brand-gradient italic">superpower</span>?
      </h2>
      <p className="font-['DM_Sans',sans-serif] text-base text-white text-center mb-10">
        {copy.hint}
      </p>
      <OptionGrid
        options={SUPERPOWERS}
        selected={superpower}
        onSelect={handleSelect}
        label={copy.question}
      />
      <div className="mt-10 w-full max-w-md">
        <SubmitButton label={copy.button} onClick={handleNext} disabled={!superpower} />
      </div>
    </ScreenLayout>
  );
}
